<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  message: {
    type: String,
    default: 'error.general'
  }
});

const emit = defineEmits(['retry']);

const VUE_ASSETS_URL = process.env.VUE_APP_ASSETS_URL

const retry = () => {
  emit('retry');
};
</script>

<template>
  <div class="error-backdrop">
    <!-- Logo centrado como fondo -->
    <img
      :src="VUE_ASSETS_URL + 'logokw.png'"
      :srcset="VUE_ASSETS_URL + 'logokw.png 1x, ' + VUE_ASSETS_URL + 'logokw@2.png 2x'"
      alt="Kiwish"
      class="error-logo"
    />
    <div class="error-box" role="alert">
      <svg class="error-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="16" r="1" fill="currentColor"/>
      </svg>
      <p class="error-message">{{ $t(message) }}</p>
      <ion-button class="retry-button" @click="retry" expand="block">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
          <path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ $t('network.retry') }}
      </ion-button>
    </div>
  </div>
</template>

<style scoped>
.error-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999998;
  background: #FF5287;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
}

.error-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: auto;
  opacity: 0.15;
}

.error-box {
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 320px;
  width: 100%;
}

.error-icon {
  color: #FF5287;
  margin-bottom: 16px;
}

.error-message {
  color: #5A695B;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 24px 0;
}

.retry-button {
  --background: #FF5287;
  --background-activated: #e94a78;
  --background-hover: #ff6b9a;
  --color: #fff;
  --border-radius: 12px;
  width: 100%;
  height: 48px;
  font-weight: 600;
}

.retry-button::part(native) {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
